import script from "./hearderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./hearderPage.vue?vue&type=script&setup=true&lang=js"

import "./hearderPage.vue?vue&type=style&index=0&id=2a1317a1&scoped=true&lang=css"

import exportComponent from "D:\\项目\\王守岩代码\\长护险\\小爱到家长护险服务运营平台4.8\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a1317a1"]])

export default __exports__